var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "social-instagram_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 5h54v54H5zm40.5 7.364h6.136V18.5H45.5zM32 18.5c-7.456 0-13.5 6.044-13.5 13.5S24.544 45.5 32 45.5 45.5 39.456 45.5 32 39.456 18.5 32 18.5",
    clipRule: "evenodd"
  })));
};
export { SvgSocialInstagram as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUgNUg1OVY1OUg1VjVaTTQ1LjUgMTIuMzYzNkg1MS42MzY0VjE4LjVINDUuNVYxMi4zNjM2Wk0zMiAxOC41QzI0LjU0NDEgMTguNSAxOC41IDI0LjU0NDEgMTguNSAzMkMxOC41IDM5LjQ1NTkgMjQuNTQ0MSA0NS41IDMyIDQ1LjVDMzkuNDU1OSA0NS41IDQ1LjUgMzkuNDU1OSA0NS41IDMyQzQ1LjUgMjQuNTQ0MSAzOS40NTU5IDE4LjUgMzIgMTguNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";